<template>

    <div>
        <div class="themePan">
            <el-radio-group v-model="query.tb" size="mini" @change="tableChange" >
                <el-radio v-for="item in selectData['tableMap']" :key="item.id" :label="item.tb" border>{{ item.name }}</el-radio>
            </el-radio-group>
        </div>
        <el-card shadow="hover" class="searchCard">
            <span class="label-span">
                <label class="label">订单时间段</label>
                <el-date-picker style="width:320px"
                                v-model="query.orderTimeArr"
                                type="daterange"
                                value-format="yyyy-MM-dd"
                                start-placeholder="开始时间"
                                end-placeholder="结束时间"
                                :picker-options="pickerOptions1"
                                class="mr10">
                </el-date-picker>
            </span>

            <span class="label-span">
                <label class="label">上游资源</label>
                <el-select v-model="query.upid" placeholder="上游资源" filterable clearable style="width:200px"
                           class="handle-select mr10">
                    <el-option value="" label="全部" />
                    <el-option v-for="item in selectData['channelOption']" :key="item.optKey" :label="item.optVal"
                               :value="item.optKey" />
                </el-select>
            </span>

            <span class="label-span">
                <label class="label">产品名称</label>
                <el-input v-model.trim="query.goodsName" placeholder="产品名称"
                          class="handle-input mr10"></el-input>
            </span>
            <span class="label-span">
                <label class="label">产品编码</label>
                <el-input v-model.trim="query.goodsCode" placeholder="产品编码"
                          class="handle-input mr10"></el-input>
            </span>
            <span class="label-span">
                <label class="label">结算状态</label>
                <el-select v-model="query.upSettlStatusQuery" placeholder="结算状态" filterable clearable
                           class="handle-select mr10">
                    <el-option value="" label="全部" />
                    <el-option v-for="item in selectData['upSettlStatusOption']" :key="item.optKey" :label="item.optVal"
                               :value="item.optKey" />
                </el-select>
            </span>
<br>
            <el-button type="success" icon="el-icon-search" class="mr10" @click="handleSearch">搜索</el-button>
            <el-button type="error" icon="el-icon-refresh" class="mr10" @click="refreshSearch">重置</el-button>
            <el-button type="error" icon="el-icon-download" class="mr10" @click="downExcel">导出</el-button>
            <el-button type="danger" class="mr10" @click="createChannelErs">生成结算函</el-button>
            <el-button type="primary" class="mr10" @click="handleStatusMore">上游结算</el-button>
        </el-card>
        <el-card shadow="hover" class="containCard">
            <el-table :data="tableData" :height="theight" border class="table"  ref="multipleTable" header-cell-class-name="table-header"
                      v-loading="loading"  element-loading-text="" element-loading-spinner="el-icon-loading">

                <el-table-column prop="upid" min-width="130" align="center" label="上游名称">
                    <template slot-scope="scope">
                        {{formatSelect('channelOption',scope.row.upid)}}
                    </template>
                </el-table-column>
                <el-table-column prop="goodsCode" min-width="120" align="center" label="产品编码"> </el-table-column>
                <el-table-column prop="goodsName" min-width="200" align="center" label="产品名称"> </el-table-column>
                <el-table-column prop="orderDate" min-width="120" align="center" label="订购日期"> </el-table-column>
                <el-table-column prop="upSettlPrice"  min-width="120" align="center" label="产品单价">
                    <template slot-scope="scope">
                        <b class='red'>{{scope.row.upSettlPrice}} </b>
                    </template>
                </el-table-column>
                <el-table-column prop="upSettlStatus" min-width="90" align="center" label="结算状态">
                    <template slot-scope="scope">
                        {{formatSelect('upSettlStatusOption',scope.row.upSettlStatus)}}
                    </template>
                </el-table-column>
                <el-table-column prop="num" min-width="90" align="center" label="结算数量"> </el-table-column>
                <el-table-column prop="totalPrice"  min-width="120" align="center" label="结算总价">
                    <template slot-scope="scope">
                        <b class='red'>{{scope.row.totalPrice}} </b>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[10, 20, 50, 100, 200,500,1000,2000]"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </el-card>

        <!-- 新建自主资源弹出框 -->
        <el-dialog :close-on-click-modal="false" title="上游结算" :visible.sync="addVisible"
                   :modal-append-to-body='false' top="80px" width="420px">
            <el-form ref="form1" :model="form1" label-width="90px">
                <el-form-item label="订单状态">
                    <el-radio-group v-model.trim="form1.status">
                        <el-radio-button v-for="item in selectData['upSettlStatusOption']" :label="item.optKey">{{item.optVal}}</el-radio-button>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm(form1.status)">确 定</el-button>
            </span>
        </el-dialog>


        <!-- 编辑自主资源弹出框 -->
        <el-dialog :close-on-click-modal="false" title="结算函" :visible.sync="editVisible"
                   :modal-append-to-body='false' top="50px" width="1120px">
            <div>
                <div style='margin-top:-20px;'>
                    <span class="label-span">
                        <label class="label2">业务方</label>
                        <el-select v-model="form2.ywCompany" @change="setCompany('1',form2.ywCompany)"
                                   placeholder="业务方" filterable clearable class="handle-select mr10">
                            <el-option v-for="item in selectData['ersAccountOption']" :key="item.id" :label="item.optVal"
                                       :value="item.optKey" />
                        </el-select>
                    </span>
                    <span class="label-span" style='margin-right:20px'>
                        <label style='margin:0 10px'>电子签章</label>
                        <el-tooltip :content="form2.ywCompanyStamp=='1'?'已开启':'已关闭'" placement="top">
                            <el-switch
                                v-model="form2.ywCompanyStamp"
                                active-color=""
                                inactive-color=""
                                active-value="1"
                                inactive-value="0">
                            </el-switch>
                        </el-tooltip>
                    </span>
                    <span class="label-span">
                        <label class="label2">推广方</label>
                        <el-select v-model="form2.tgCompany" @change="setCompany('2',form2.tgCompany)"
                                   placeholder="推广方" filterable clearable class="handle-select mr10">
                                <el-option v-for="item in selectData['ersAccountOption']" :key="item.id" :label="item.optVal"
                                           :value="item.optKey" />
                        </el-select>
                    </span>
                    <span class="label-span" style='margin-right:20px'>
                        <label style='margin:0 10px'>电子签章</label>
                        <el-tooltip :content="form2.tgCompanyStamp=='1'?'已开启':'已关闭'" placement="top">
                            <el-switch
                                v-model="form2.tgCompanyStamp"
                                active-color=""
                                inactive-color=""
                                active-value="1"
                                inactive-value="0">
                            </el-switch>
                        </el-tooltip>
                    </span>

                    <el-button @click="exportToImage">下载结算函</el-button>
                    <el-button @click="saveForm('1')">预结算</el-button>
                </div>

                <!-- 目标转换区域，通过 ref 标记 -->
                <div ref="captureElement">
                    <!-- 需转换为图片的HTML内容 -->
                    <h1 style='text-align: center;margin:15px 0 10px 0;'>{{ query.cname }}结算函</h1>
                    <table class='myTable' style='margin-top:15px;'>
                        <tr class='myTable_th'>
                            <td style='width:170px'>结算账期</td>
                            <td>业务名称</td>
                            <td style='width:60px'>推广量</td>
                            <td style='width:60px'>单价</td>
                            <td style='width:70px'>应结</td>
                            <td style='width:60px'>核减</td>
                            <td style='width:150px'>备注</td>
                            <td style='width:90px'>实结</td>
                        </tr>
                        <tr class='myTable_tr' v-for="(item,index) in cashList" :key="index">
                            <td>{{ query.orderTimeArr[0] }} - {{ query.orderTimeArr[1] }}</td>
                            <td>{{ item.goodsName }}</td>
                            <td>{{ item.num }}</td>
                            <td>{{ item.upSettlPrice }}</td>
                            <td>{{ item.totalPrice }}</td>
                            <td><input class='inputHidden' @change='cashHj' oninput="value=value.replace(/[^0-9.]/g,'')"
                                       style='width:50px;text-align: left' v-model.trim="item.fb1"></td>
                            <td><input class='inputHidden' style='width:140px;text-align: left' v-model.trim="item.fb2">
                            </td>
                            <td :class="'totalSj'+index">{{ item.fb3 }}</td>
                        </tr>
                        <tr class='myTable_tr'>
                            <td colspan='4' style='text-align: right;border:none;font-weight: bold'>统计：</td>
                            <td colspan='3' style=' border:none;font-weight: bold'>{{ form.totalSum }}</td>
                            <td class='totalSumSj' style=' border:none;font-weight: bold'>{{ form.totalSumSj }}</td>
                        </tr>
                        <tr class='myTable_tr'>
                            <td colspan='3'>
                                <b>业务方：</b><span
                                v-if='this.ywCompany'>&nbsp;&nbsp;&nbsp;{{ ywCompany.companyName }}<br>
                                <b>公司税号：</b>{{ ywCompany.companyCode }}<br>
                                <b>开户银行：</b>{{ ywCompany.bankName }}<br>
                                <b>银行账户：</b>{{ ywCompany.bankCardNum }}<br>
                                <b>公司地址：</b>{{ ywCompany.companyAddress }}<br>
                                <b>联系电话：</b>{{ ywCompany.companyTel }}</span>
                                <img :src='ywCompany.stamp' class='stampImg' :hidden='form2.ywCompanyStamp==0'>
                            </td>
                            <td colspan='5'>
                                <b>推广方：</b><span
                                v-if='this.tgCompany'>&nbsp;&nbsp;&nbsp;{{ tgCompany.companyName }}<br>
                                <b>公司税号：</b>{{ tgCompany.companyCode }}<br>
                                <b>开户银行：</b>{{ tgCompany.bankName }}<br>
                                <b>银行账户：</b>{{ tgCompany.bankCardNum }}<br>
                                <b>公司地址：</b>{{ tgCompany.companyAddress }}<br>
                                <b>联系电话：</b>{{ tgCompany.companyTel }}</span>
                                <img :src='tgCompany.stamp' class='stampImg' :hidden='form2.tgCompanyStamp==0'>
                            </td>
                        </tr>
                    </table>

                </div>

            </div>
        </el-dialog>

        <el-dialog :title="query.cname+'结算函'" :modal-append-to-body='false' :visible.sync="detailVisible"
                   width="800px" top="30px" height="100%">
            <iframe :src="linkUrl" frameborder="0" style="margin-top:-15px;" width="100%" height="600px"></iframe>
        </el-dialog>


    </div>

</template>

<script>
import $ from 'jquery' ;
import {
    getMonthRange,
    getMonthRangeByCurrent,
    getMonthRangeByYearAndMonth,
    getPreviousDateRange
} from '@/utils/dateUtils';
import selectManager from '@/utils/selectUtils2';
import { fetchListData,downCashExcel,getDataByChannelCash,updateSettlStatus} from '@/api/orderSettlement';
import { getData } from '../../api/ersAccount';  //渠道名称
import html2canvas from 'html2canvas';

export default {
    data() {
        return {
            formatSelect:selectManager.formatSelect.bind(selectManager),
            pickerOptions1: {
                shortcuts: [{
                    text: '当月',
                    onClick(picker) {
                        picker.$emit('pick', getMonthRangeByCurrent());
                    }
                }, {
                    text: '上月',
                    onClick(picker) {
                        picker.$emit('pick', getMonthRange(1));
                    }
                }, {
                    text: '2月前',
                    onClick(picker) {
                        picker.$emit('pick', getMonthRange(2));
                    }
                }],
                disabledDate(time) {
                    // 禁用今天及今天之后的所有时间
                    const today = new Date();
                    today.setHours(0, 0, 0, 0); // 将时间归零到当天00:00:00
                    return time.getTime() > today.getTime(); // 严格比较当天及之后
                }
            },
            selectData:{
                upSettlStatusOption:[
                    // {optKey:'0',optVal:'待核对',type:'info'},
                    {optKey:'1',optVal:'已结算',type:'success'},
                    {optKey:'2',optVal:'待结算',type:'warning'},
                    {optKey:'3',optVal:'不结算',type:'danger'}
                ],
            },
            query: {
                pageIndex: 1,
                pageSize: 10,
                dataKey:'up',
                orderTimeArr: getMonthRangeByCurrent(),
                upSettlStatusQuery: '',
                tb:'@',
            },
            tableData: [],


            dialogFormVisible: false,
            formLabelWidth: '120px',
            dynamicText: '示例数据',
            imageUrl: '',
            formattedJson: '',
            Timeout: '',
            activeNames: 1,
            theight: '480px',
            theight2: '500px',
            select: { option: '' },
            ywCompany: '',
            tgCompany: '',
            sendSms: {
                code: '',
                content: '发送验证码',
                type: 'danger',
                disabled: false,
                color: 'color:#fff'
            },
            formImg: {
                img2: '',
                img3: ''
            },
            multipleSelection: [],
            delList: [],
            showDiv: true,
            showDiv2: true,
            show: 'v',
            show2: '● 查看接口请求数据 >',
            editVisible: false,
            editPlusVisible: false,
            addVisible: false,
            addPlusVisible: false,
            detailVisible: false,
            linkUrl: '',
            backVisible: false,
            stepVisible: false,
            drawVisible: false,
            loading: false,
            row: {},
            pageTotal: 0,
            formtd: {
                upid: '',
                startTime: '',
                endTime: '',
                file: ''
            },
            form: {
                totalSumsj: 0,
                totalSum: 0
            },
            cashList: [],
            form1: {
                status: '1'
            },
            form2: { ywCompany: '', tgCompany: '', ywCompanyStamp: '0', tgCompanyStamp: '0' },
            form3: { phone: '', sms: '' },
            form4: {},
            form5: {},
            form6: {},
            form7: {},
            idx: -1,
            id: -1,
            ids: ''
        };
    },
    components: {},
    created() {
        // 初始化工具类中的Vue实例
        selectManager.initialize(this,this.selectData);
        // 加载下拉框数据
        this.loadDropdownData();
    },
    //页面加载方法
    mounted: function() {
        this.getData();
        // this.$message.warning('只对7天前的订单数据进行财务汇总');
    },
    beforeDestroy() {
        // 离开前保存 query 到本地
        localStorage.setItem('comOrderQuery', JSON.stringify(this.query));
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
    },

    methods: {
        initPickerOptions(){
            let tb = this.query['tb'];

            if (tb === '@') {
                this.$set(this,"pickerOptions",this.$options.data().pickerOptions);
                return;
            }

            let orderTimeArr = getMonthRangeByYearAndMonth(tb,12)
            this.$set(this.query,"orderTimeArr",orderTimeArr);

            let shortcuts = [];
            for (let i = 12; i > 0; i--) {
                let m = i.toString().padStart(2, '0');
                shortcuts.push({
                    text: tb + '-' + m,
                    onClick: (picker) => {
                        picker.$emit('pick', getMonthRangeByYearAndMonth(tb, i));
                    }
                })
            }
            this.$set(this.pickerOptions,"shortcuts", shortcuts);
            let disabledDate = (time) => {
                const today = new Date(time);
                let year = today.getFullYear().toString()
                return year !== tb;
            }
            this.$set(this.pickerOptions,"disabledDate", disabledDate);
        },
         loadDropdownData() {
            selectManager.getOption("tableMap");
            // 加载上游渠道下拉框数据
            selectManager.getOption("channelOption");
        },
        cashHj() {
            var totalSumsj = 0;
            for (var i = 0; i < this.cashList.length; i++) {
                if (parseFloat(this.cashList[i].total) < parseFloat(this.cashList[i].fb1)) {
                    this.$message.error('核减金额不得超过应结金额！');
                    return;
                }
                var totalSj = parseFloat(this.cashList[i].total) - parseFloat(this.cashList[i].fb1);
                $('.totalSj' + i).text(totalSj);
                totalSumsj += totalSj;
            }
            this.form.totalSumsj = totalSumsj;
            $('.totalSumSj').text(totalSumsj);
        },
        setCompany(i, id) {
            let data = {};
            data.id = id;
            getData(data).then(res => {
                if (res.code == '200') {
                    if (i == 1) {
                        this.ywCompany = res.data;
                    } else if (i == 2) {
                        this.tgCompany = res.data;
                    }
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            this.theight = '480px';
            columns.forEach((column, index) => {
                if (index == 0) {//只找第一列放合计
                    sums[index] = '统计';
                    return;
                }
                if (index < 5) {
                    sums[index] = '';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));//把对应一列中的之全部取出，放到一个数组中
                if (!values.every(value => isNaN(value))) {//如果el-table-column中没有prop属性，这里的column.property是undefined，所以判断一下values数组是否为空
                    sums[index] = values.reduce((prev, curr) => {
                        console.log(prev, curr);
                        const value = Number(curr);//将values中的每个值转换为number类型
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    if (index == 5) {
                        sums[index] += '元';
                    }
                } else {
                    sums[index] = 0;
                }
            });
            window.setTimeout(() => {
                this.theight = this.theight2;
            }, 500);
            return sums;
        },
        async exportToImage() {
            if (!this.form2.ywCompany) {
                this.$message.error('请选择业务方');
                return;
            }
            if (!this.form2.tgCompany) {
                this.$message.error('请选择推广方');
                return;
            }
            try {
                // 获取DOM元素
                const element = this.$refs.captureElement;

                // 配置选项（关键优化）
                const canvas = await html2canvas(element, {
                    useCORS: true,      // 解决跨域图片加载问题
                    scale: 2,           // 提高输出分辨率（2倍）
                    backgroundColor: '#ffffff', // 设置白色背景
                    logging: false      // 关闭调试日志
                });

                // 转换为DataURL并保存
                this.imageUrl = canvas.toDataURL('image/png');
                this.downloadImage(canvas);
            } catch (error) {
                console.error('转换失败：', error);
                alert('生成图片失败，请重试');
            }
        },
        downloadImage(canvas) {
            const link = document.createElement('a');
            link.href = canvas.toDataURL('image/png');
            link.download = '截图.png'; // 自定义文件名
            link.click();
        },

        // 触发搜索按钮 
        handleSearch() {
            let back = this.validateTimeRange();
            if(back !== 'ok'){
                this.$message.warning(back);
                return;
            }
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },

        //重置按钮
        refreshSearch(){
            let tb = this.query['tb'];
            this.$set(this,"query",this.$options.data().query);
            this.$set(this.query,"tb",tb);
            this.initPickerOptions();
            this.handleSearch();
        },

        tableChange(){
            this.refreshSearch();
        },

        validateTimeRange() {
            if(!this.query.tb){
                return '请选择数据范围';
            }

            if (!(this.query.orderTimeArr && this.query.orderTimeArr.length === 2)) {
                return 'ok';
            }

            const [start, end] = this.query.orderTimeArr;
            const startTime = new Date(start);
            const endTime = new Date(end);

            if(this.query.tb === '@' ){
                const nowDate = new Date();
                const threeMonthsAgo = new Date(nowDate);
                threeMonthsAgo.setMonth(nowDate.getMonth() - 3);
                if (startTime < threeMonthsAgo || endTime > nowDate) {
                    return '订单时间段超出数据范围';
                }
            }else{
                if (startTime.getFullYear().toString() !== this.query.tb) {
                    return '订单时间段超出数据范围 start：'+this.query.tb;
                }
                if (endTime.getFullYear().toString() !== this.query.tb) {
                    return '订单时间段超出数据范围 end：'+this.query.tb;
                }
            }
            return 'ok';
        },

        getMore(data) {
            this.$notify({ message: data, duration: 3000 });
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },

        //触发刷新按钮
        refresh() {
            history.go(0);

        },

        downExcel() {
            this.queryCheck(param=>{
                this.loading = true;
                setTimeout(() => {
                    if (this.loading) {
                        this.loading = false;
                        this.getData();
                    }
                }, 7000);
                downCashExcel(param).then(res => {
                    this.loading = false;
                    if (res.code == '200') {
                        this.$notify({ title: '成功', message: res.message, duration: 5000, type: 'success' });
                    } else {
                        this.$notify({ title: '失败', message: '后台下载异常', duration: 5000, type: 'error' });
                    }
                });
            })
        },
        //查询
        getData() {
            this.queryCheck(param=>{
                this.loading = true;
                fetchListData(param).then(res => {
                    this.loading = false;
                    if (res.code == '200') {
                        this.tableData = res.data.list;
                        this.pageTotal = res.data.pageTotal;
                    } else {
                        this.tableData = [];
                        this.pageTotal = 0;
                    }
                });
            })
        },

        copyLink(text, name) {
            var copy = document.createElement('input');
            copy.setAttribute('value', text);
            document.body.appendChild(copy);
            copy.select();
            document.execCommand('copy');
            document.body.removeChild(copy);
            //提示已复制
            this.$message.success(name + '复制成功');
        },


        handleRemarksMore() {
            const length = this.multipleSelection.length;
            if (length === 0) {
                this.$message.error('请勾选要备注的订单');
                return;
            }
            this.ids = '';
            for (let i = 0; i < length; i++) {
                this.ids += this.multipleSelection[i].id + ',';
            }
            this.ids = this.ids.substr(0, this.ids.length - 1);
            this.form3.id = this.ids;
            this.editVisible = true;
        },

        // 保存更改
        saveEdit() {
            if (!this.form3.remarks) {
                this.$message.error('请填写订单备注');
                return;
            }
            updateMore(this.form3).then(res => {
                if (res.code == '200') {
                    this.editVisible = false;
                    this.$message.success(res.message);
                    this.getData();
                } else {
                    this.$message.error(res.message);
                }
            });
        },

        queryCheck(action){
            let param = {
                ...this.query,
            }
            if(this.query.orderTimeArr && this.query.orderTimeArr.length > 1){
                param.startTime = this.query.orderTimeArr[0] + " 00:00:00";
                param.endTime = this.query.orderTimeArr[1] + " 23:59:59";
            }
            if (!param.startTime || !param.endTime) {
                this.$message({
                    message: '订单日期范围不能为空',
                    type: 'warning'
                });
                return;
            }
            action(param);
        },

        // 修改状态
        setStatus(row) {
            this.form1 = row;
            this.addVisible = true;
        },

        handleStatusMore() {
            this.addVisible = true;
        },
        createChannelErs() {
            this.loading = true;
            this.queryCheck(param=>{
                selectManager.getOption('ersAccountOption');
                getDataByChannelCash(param).then(res => {
                    if (res.code == '200') {
                        var list = res.data.list;
                        var totalSumSj = res.data.totalSumSj;
                        var totalSum = res.data.totalSum;
                        this.cashList = list;
                        this.form.totalSumSj = totalSumSj;
                        this.form.totalSum = totalSum;
                        this.editVisible = true;
                        this.loading = false;
                    } else {
                        this.loading = false;
                        this.$message.error(res.message);
                    }
                });
            })
            /*
            const queryString = Object.entries(this.query)
                .filter(([_, value]) => value != null && value !== '') // 过滤空值
                .map(([key, value]) => {
                    return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
                }).join('&');
            var mid = localStorage.getItem(window.location.hostname + '_mid');
            var host = localStorage.getItem(window.location.hostname + '_stationUrl');
            this.linkUrl = window.location.protocol + '//' + host + '/h5/cash/channel_'+mid+'?' + queryString; */

        },
        //保存新增
        saveForm(status) {
            this.queryCheck(param=>{
                param['upSettlStatus'] = status;
                updateSettlStatus(param).then(res => {
                    if (res.code == '200') {
                        this.addVisible = false;
                        this.$message.success(res.message);
                        this.getData();
                    } else {
                        this.$message.error(res.message);
                    }
                });
            })
        },

        // q启用、禁用--改变状态
        handleStatus(index, row) {
            var tips;
            var content;
            if (row.status == '0') {
                tips = '禁用';
                content = '确定禁用吗？';
            } else {
                tips = '启用';
                content = '确定启用吗？';
            }
            // 二次确认删除
            this.$confirm(content, '提示', {
                type: 'warning'
            }).then(() => {
                changeStatus(row).then(res => {
                    if (res.code == '200') {
                        this.$message.success(tips + '成功');
                        this.getData();
                    } else {
                        this.$message.error(tips + '失败');
                    }
                });
            })
                .catch(() => {
                });

        },


        //详情
        handleDetail(row) {
            getOrderDetail(row).then(res => {
                if (res.code == '200') {
                    if (res.data == null) {
                        this.$message.error('暂无数据');
                        return;
                    }
                    this.detailVisible = true;
                    this.form2 = res.data;
                    this.form3.phone = row.phone;
                    this.form3.sms = row.sms;
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        handleStep(row) {
            getOrderStep(row).then(res => {
                if (res.code == '200') {
                    this.stepVisible = true;
                    //apiCallLogList
                    // comOrderStepList
                    this.form4 = res.data.comOrderStepList;
                    this.form7 = res.data.apiCallLogList;
                    this.form5 = row;
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        handleBack(row) {
            getOrderBack(row).then(res => {
                if (res.code == '200') {
                    this.backVisible = true;
                    this.form6 = res.data;
                    this.form5 = row;
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        // 删除
        handDelete(index, row) {
            this.form.id = row.id;
            // 二次确认删除
            this.$confirm('该资源所有商品将删除，是否要删除？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(this.form).then(res => {
                    if (res.code == '200') {
                        this.$message.success('删除成功');
                        this.$set(this.query, 'pageIndex', 1);
                        this.getData();
                    } else if (res.code == '201') {
                        //处理该等级绑定的成员
                        this.$message.error('该资源商品仍有订单未结算，请手动结算订单！');
                    } else {
                        this.$message.error('删除失败');
                    }
                });
            });
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val) {
            this.$set(this.query, 'pageSize', val);
            this.getData();
        },
        beforeUpload(file) {

            const isValidSize = file.size / 1024 / 1024 < 20;
            const isExcel = file.name.endsWith('.xlsx') || file.name.endsWith('.xls');
            if (!isExcel) {
                this.$message.error('只能上传 Excel 文件 (.xlsx, .xls)');
                return false; // 阻止上传
            }
            return true;
            if (!isValidSize) {
                this.$message.error('文件大小不能超过 20MB');
            }

            return isValidType && isValidSize;
        },
        customUpload(fileObj) {
            const formData = new FormData();
            // 添加文件
            formData.append('file', fileObj.file);
            // 添加其他字段
            formData.append('upid', this.formtd.upid); // 上游资源名称
            formData.append('startTime', this.formtd.startTime); // 开始时间
            formData.append('endTime', this.formtd.endTime); // 结束时间

            // 发送请求
            uploadExcel(formData).then(res => {
                if (res.code === '200') {
                    this.$message.success(res.message);
                    this.dialogFormVisible = false; // 关闭弹窗
                    this.resetFormtd();
                } else {
                    this.$message.error('上传失败: ' + res.message);
                }
            }).catch(err => {
                this.$message.error('上传过程中发生错误: ' + err);
            });
        },
        resetFormtd() {
            this.formtd = {
                upid: '',
                startTime: '',
                endTime: '',
                file: ''
            };
        },
        resetForm(formName) {
            this.$refs[formName].resetFields(); // 重置表单验证
            this.resetFormtd(); // 重置 formtd 数据
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // 手动触发上传
                    this.$refs.uploadRef.submit();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }
    }
};
</script>
<style>
.el-drawer__open .el-drawer.ttb {
    height: 100% !important;
}
</style>
<style scoped>

:v-deep .el-icon-arrow-right:before {
    color: #1890ff;
    font-size: 20px;
    font-weight: 700;
}

::v-deep .el-table__expand-icon .el-icon-arrow-right:before {

    font-size: 15px;
    color: #409EFF;
    text-align: center;
}

::v-deep .el-table__expand-icon--expanded .el-icon-arrow-right:before {
    font-size: 15px;
    color: #999;
    text-align: center;
}


.handle-box {
    width: 100%;
    margin-bottom: 20px;
    overflow-x: auto;
}

.handle-select {
    width: 145px;
    display: inline-block;
}

.handle-input {
    width: 145px;
    display: inline-block;
}

.handle-del {
    float: right;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
    margin-left: 0;
}

.mr15 {
    margin-right: 15px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
<style>
.el-table__row--level-1 {
    background-color: #efefef !important;
}

.el-table__row--level-1:hover {
    background-color: #efefef !important;
}

.el-table__row--level-1::after {
    background-color: #efefef !important;
}

.el-table--small .el-table__cell {
    padding: 3px 2px;
}

.el-table .cell {
    padding: 3px 2px;
}

.white-space-pre-line {
    white-space: pre-line; /* 保留换行符，自动合并空格 */
}

.stampImg {
    width: 192px;
    margin-top: -180px;
    margin-left: 260px;
}


input.notborder[disabled] {
    border-bottom: none; /* 移除边框 */
    cursor: not-allowed; /* 禁用光标 */
}
.inputStyle{
    height:28px;
    text-align:center;
    border:none;
    border-bottom:1px solid orange;
    background: none;
    color:orange;
}

.inputStyle::placeholder{
    color:#bbb;
}
.inputStyle:focus {
    outline:none;
    border-bottom:2px solid red;
}

</style>
